import { getWarningTextForIncompleteIntegration } from '@modules/integrationsV2/utils';
import { getIsIncompleteIntegrationData } from '@modules/integrationsV2/utils/getIsIncompleteIntegrationData';
import { Alert, Box } from '@mui/material';
import {
  IntegrationChannelType,
  IntegrationViewFragment,
} from 'generated/graphql';

interface EditIntegrationIncompleteWarningAlertProps {
  integrationData: IntegrationViewFragment['data'];
  channelType: IntegrationChannelType;
}

export const EditIntegrationIncompleteWarningAlert = ({
  integrationData,
  channelType,
}: EditIntegrationIncompleteWarningAlertProps) => {
  const shouldShowWarning = getIsIncompleteIntegrationData({
    integrationData,
    channelType,
  });

  if (!shouldShowWarning) {
    return null;
  }

  return (
    <Box pt={1} pb={3}>
      <Alert
        severity="warning"
        sx={{
          border: '1px solid',
          borderColor: 'warning.main',
        }}
      >
        {getWarningTextForIncompleteIntegration(channelType)}
      </Alert>
    </Box>
  );
};
